/**
 * @param {string} inputHtml
 * @param {{
 *   XRegExp?: any,
 *   startPosition?: number,
 *   onEachSpan?: (position: number, offset: number, cumulativeOffset: number) => void,
 *   language?: string,
 *   ignoreStrong?: boolean,
 *   includePunctuation?: boolean,
 * }} options
 *
 * @returns {{
 *   html: string;
 *   totalSpans: number;
 * }}
 */
export default function (inputHtml, options) {
  // XXX Warning: Changing this var to a const causes an error!
  // eslint-disable-next-line no-var
  var XRegExp = XRegExp || options.XRegExp;

  /** Warning: this also includes punctuation */
  const wordRegExp = options.includePunctuation
    ? XRegExp(`([’'\\p{L}\\p{M}]+|[0-9]+|[«»"”“.,?!¡¿])`, "g")
    : XRegExp("([’'\\p{L}\\p{M}]+|[0-9]+)", "g");

  let cumulativeOffset = 0;
  let position = options.startPosition || 0;

  XRegExp.addUnicodePackage({
    Han: "2E80-2E992E9B-2EF32F00-2FD5300530073021-30293038-303B3400-4DB54E00-9FCCF900-FA6DFA70-FAD9",
    Hiragana: "3041-3096309D-309F",
    Katakana: "30A1-30FA30FD-30FF31F0-31FF32D0-32FE3300-3357FF66-FF6FFF71-FF9D",
    Thai: "0E00-0E7F",
    M: "0300-036F0483-04890591-05BD05BF05C105C205C405C505C70610-061A064B-065F067006D6-06DC06DF-06E406E706E806EA-06ED07110730-074A07A6-07B007EB-07F30816-0819081B-08230825-08270829-082D0859-085B08E4-08FE0900-0903093A-093C093E-094F0951-0957096209630981-098309BC09BE-09C409C709C809CB-09CD09D709E209E30A01-0A030A3C0A3E-0A420A470A480A4B-0A4D0A510A700A710A750A81-0A830ABC0ABE-0AC50AC7-0AC90ACB-0ACD0AE20AE30B01-0B030B3C0B3E-0B440B470B480B4B-0B4D0B560B570B620B630B820BBE-0BC20BC6-0BC80BCA-0BCD0BD70C01-0C030C3E-0C440C46-0C480C4A-0C4D0C550C560C620C630C820C830CBC0CBE-0CC40CC6-0CC80CCA-0CCD0CD50CD60CE20CE30D020D030D3E-0D440D46-0D480D4A-0D4D0D570D620D630D820D830DCA0DCF-0DD40DD60DD8-0DDF0DF20DF30E310E34-0E3A0E47-0E4E0EB10EB4-0EB90EBB0EBC0EC8-0ECD0F180F190F350F370F390F3E0F3F0F71-0F840F860F870F8D-0F970F99-0FBC0FC6102B-103E1056-1059105E-10601062-10641067-106D1071-10741082-108D108F109A-109D135D-135F1712-17141732-1734175217531772177317B4-17D317DD180B-180D18A91920-192B1930-193B19B0-19C019C819C91A17-1A1B1A55-1A5E1A60-1A7C1A7F1B00-1B041B34-1B441B6B-1B731B80-1B821BA1-1BAD1BE6-1BF31C24-1C371CD0-1CD21CD4-1CE81CED1CF2-1CF41DC0-1DE61DFC-1DFF20D0-20F02CEF-2CF12D7F2DE0-2DFF302A-302F3099309AA66F-A672A674-A67DA69FA6F0A6F1A802A806A80BA823-A827A880A881A8B4-A8C4A8E0-A8F1A926-A92DA947-A953A980-A983A9B3-A9C0AA29-AA36AA43AA4CAA4DAA7BAAB0AAB2-AAB4AAB7AAB8AABEAABFAAC1AAEB-AAEFAAF5AAF6ABE3-ABEAABECABEDFB1EFE00-FE0FFE20-FE26",
  });
  const hanRegExp = new XRegExp(
    "[\\p{Han}\\p{Hiragana}\\p{Katakana}\\p{Thai}]"
  );
  const combiningMark = new XRegExp("\\p{M}");
  let ignoring = false;

  const html = inputHtml.replace(
    wordRegExp,
    (wholeMatch, group1, offset, wholeString) => {
      if (wholeString[offset - 1] === "<") {
        if (group1 === "strong") {
          ignoring = true;
        }
        return group1;
      } else if (
        wholeString[offset - 2] === "<" &&
        wholeString[offset - 1] === "/"
      ) {
        if (group1 === "strong") {
          ignoring = false;
        }
        return group1;
      } else if (wholeString[offset - 1] === "&") {
        return group1;
      } else if (
        wholeString[offset - 2] === "<" &&
        wholeString[offset - 1] === "h"
      ) {
        // Ignore <h1> <h2> etc.
        return group1;
      } else if (
        wholeString[offset - 3] === "<" &&
        wholeString[offset - 2] === "/" &&
        wholeString[offset - 1] === "h"
      ) {
        // Ignore </h1> </h2> etc.
        return group1;
      }

      if (options.ignoreStrong && ignoring) {
        return group1;
      }

      if (options.onEachSpan) {
        options.onEachSpan(position, offset, cumulativeOffset);
      }

      let startTag;
      let endTag;

      if (hanRegExp.test(group1)) {
        let result = "";
        for (let i = 0; i < group1.length; i++) {
          startTag = "<span data-p=" + position++ + ">";
          endTag = "</span>";

          result += startTag + group1[i];
          while (i < group1.length - 1 && combiningMark.test(group1[i + 1])) {
            i++;
            result += group1[i];
          }

          result += endTag;
          cumulativeOffset += startTag.length + endTag.length;
        }
        return result;
      }

      startTag = "<span data-p=" + position++ + ">";
      endTag = "</span>";

      if (options.language === "ca") {
        const delimiterResult = /['`’]/.exec(group1);

        if (delimiterResult && delimiterResult.length > 0) {
          const delimiter = delimiterResult[0];

          const split = group1.split(delimiter);

          if (split[0].length <= split[1].length) {
            split[0] += delimiter;
          } else {
            split[1] = delimiter + split[1];
          }

          // TODO: is this messing up the cumulativeOffset??
          startTag = "<span data-p=" + position++ + ">";
          group1 = split[0] + endTag + startTag + split[1];

          cumulativeOffset += startTag.length + endTag.length;
          startTag = "<span data-p=" + (position - 2) + ">";
        }
      }

      cumulativeOffset += startTag.length + endTag.length;
      return startTag + group1 + endTag;
    }
  );

  return {
    html: html,
    totalSpans: position,
  };
}
